import { AbstractControl, ValidatorFn } from '@angular/forms';

export function UsernameValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null =>
        control.value && control.value.startsWith(' ') ? { UsernameError: true } : null;
}
